import { GetOfficeSuppliesApiParameter } from "@GeriMed/Services/OfficeSuppliesService";
import ApplicationStateGeriMed from "@GeriMed/Store/GeriMedState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { createContext } from "react";

// export function getOfficeSuppliesDataView(state: ApplicationStateGeriMed) {
//     const data = getDataView(state.dataOfficeSuppliesState,undefined);
//     return data;
// }
export function getOfficeSuppliesDataView(state: ApplicationStateGeriMed, parameter: GetOfficeSuppliesApiParameter) {
    const data = getDataView(state.dataOfficeSupplies,parameter);
    return data;
}

export const OfficeSuppliesDataViewContext = createContext<ReturnType<typeof getOfficeSuppliesDataView>>({
    value: undefined,
    isLoading: false,
});
